import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-373b20a2"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "outer" };
const _hoisted_2 = ["disabled"];
import { store } from '@/store/store';
import { ref, watchEffect, watch } from 'vue';
import { useMousePressed } from '@vueuse/core';
import { useRagExpTmplate } from '@/const/regexp';
import MaterialIcon from '@/materials/atoms/MaterialIcon.vue';
import BigNumber from 'bignumber.js';
export default /*#__PURE__*/ _defineComponent({
    props: {
        min: { default: 0 },
        step: { default: 0.01 },
        reference: { default: 0 },
        disabled: { type: Boolean, default: false },
        width: { default: 150 },
        height: { default: 20 },
        fontSize: { default: 14 },
        plusMinus: { type: Boolean, default: false },
        mode: null
    },
    setup(__props) {
        var _a, _b;
        const props = __props;
        const plusButton = ref(null);
        const { pressed: pressedPlus, sourceType: sourceTypePlus } = useMousePressed({
            target: plusButton,
        });
        const minusButton = ref(null);
        const { pressed: pressedMinus, sourceType: sourceTypeMinus } = useMousePressed({
            target: minusButton,
        });
        const step = -Math.log10(props.step);
        const isAmountMode = props.mode === 'Amount';
        const value = ref();
        value.value = isAmountMode ? store.state.order.amount : store.state.order.price;
        const before = ref(value.value);
        // 数値入力の整形
        const formatInput = (changedValue) => {
            if (!changedValue) {
                value.value = 0;
                before.value = 0;
                setValue(value.value);
                return;
            }
            if (changedValue.slice(0, 1) === '0' && changedValue.slice(0, 2) !== '0.') {
                changedValue = changedValue.length === 2 ? changedValue.slice(1) : changedValue.slice(0, 1);
                value.value = changedValue;
            }
            if (changedValue.slice(0, 1) === '.') {
                changedValue = '0' + changedValue;
                value.value = changedValue;
            }
            if (!isNumber(changedValue)) {
                value.value = before.value;
                return;
            }
            setValue(changedValue);
            before.value = changedValue;
        };
        const coefficient = new BigNumber((_a = process.env.VUE_APP_TRADE_STEP_COEFFICIENT) !== null && _a !== void 0 ? _a : 1);
        const longClickThreshold = new Number((_b = process.env.VUE_APP_LONG_CLICK_THRESHOLD) !== null && _b !== void 0 ? _b : 300);
        const onPlus = (start, first) => {
            if (!pressedPlus.value || (!first && Date.now() <= start + longClickThreshold)) {
                return;
            }
            const current = new BigNumber(value.value);
            const plus = new BigNumber(props.step).multipliedBy(coefficient);
            value.value = current.plus(plus).toString(10);
            const delay = first ? longClickThreshold : 50;
            setTimeout(() => onPlus(start, false), delay);
        };
        const onMinus = (start, first) => {
            if (!pressedMinus.value || (!first && Date.now() <= start + longClickThreshold)) {
                return;
            }
            const current = new BigNumber(value.value);
            if (current.isEqualTo(new BigNumber(0))) {
                return;
            }
            const minus = new BigNumber(props.step).multipliedBy(coefficient);
            value.value = current.minus(minus).toString(10);
            const delay = first ? longClickThreshold : 50;
            setTimeout(() => onMinus(start, false), delay);
        };
        const setValue = (value) => {
            if (props.mode === 'Amount') {
                store.state.order.amount = value;
            }
            else {
                store.state.order.price = value;
            }
        };
        const { realNumberReg } = useRagExpTmplate();
        const isNumber = (value) => {
            // 小数部通貨により可変
            const isDigits = realNumberReg(step).test(value);
            return isDigits;
        };
        watchEffect(() => {
            value.value = isAmountMode ? store.state.order.amount : store.state.order.price;
        });
        watch(pressedPlus, () => {
            sourceTypePlus.value === 'touch' && pressedPlus.value && onPlus(Date.now(), true);
        });
        watch(pressedMinus, () => {
            sourceTypeMinus.value === 'touch' && pressedMinus.value && onMinus(Date.now(), true);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (__props.plusMinus)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        ref_key: "minusButton",
                        ref: minusButton,
                        class: "plusMinus minus"
                    }, [
                        _createVNode(MaterialIcon, {
                            name: "remove",
                            class: "icon"
                        })
                    ], 512))
                    : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("input", {
                    class: _normalizeClass(["common", __props.disabled ? 'disabled' : '']),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((value).value = $event)),
                    onInput: _cache[1] || (_cache[1] = ($event) => (formatInput(value.value))),
                    disabled: __props.disabled,
                    style: _normalizeStyle(`width: calc(100% - ${__props.plusMinus ? '108px' : '52px'}); padding-right: ${__props.plusMinus ? '102px' : '46px'}; height: ${props.height}px; font-size: ${props.fontSize}px`),
                    inputmode: "numeric"
                }, null, 46, _hoisted_2), [
                    [_vModelText, value.value]
                ]),
                (__props.plusMinus)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        ref_key: "plusButton",
                        ref: plusButton,
                        class: "plusMinus plus"
                    }, [
                        _createVNode(MaterialIcon, {
                            name: "add",
                            class: "icon"
                        })
                    ], 512))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
